module.exports = __webpack_public_path__ + "static/media/bbss_logo_line.3d9f9a35.png";